<template>
  <v-main>
    <v-container fluid grid-list-xs pt-5>
      <v-layout row wrap justify-center align-center>
        <v-flex xs11 lg11>
          <h2>
            <v-icon
              style="cursor: pointer"
              color="#077893"
              @click="Fn_BackIndex"
              size="38"
              >mdi-chevron-left</v-icon
            >{{ $t("BotOnePlatform.create_bot") }}
          </h2>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center align-center pa-1>
        <v-flex xs11 lg11>
          <v-form ref="form" v-model="valid">
            <v-card class="rounded-lg">
              <v-card-title primary-title>
                {{ $t("BotOnePlatform.group_sent_data") }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-5">
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>ชื่อกลุ่ม (Groupsent Name) <span style="color: red">*</span></b>
                    <v-text-field
                      outlined
                      dense
                      color="#077893"
                      v-model="Name"
                      maxlength="200"
                      prepend-inner-icon="mdi-account-outline"
                      :rules="[(v) => !!v || 'กรุณากรอกข้อมูลให้ครบถ้วน']"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!-- <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>Account ID</b>
                    <v-text-field
                      hide-details
                      outlined
                      disabled
                      dense
                      color="#077893"
                      v-model="AccountId"
                      prepend-inner-icon="mdi-account-outline"
                    ></v-text-field>
                  </v-flex>
                </v-layout> -->
                <!-- <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>Business ID</b>
                    <v-text-field
                      hide-details
                      outlined
                      disabled
                      dense
                      color="#077893"
                      v-model="BusinessId"
                      prepend-inner-icon="mdi-account-outline"
                      :rules="[(v) => !!v || 'กรุณากรอกชื่อผู้ส่ง']"
                    ></v-text-field>
                  </v-flex>
                </v-layout> -->
                <v-layout row wrap justify-center align-center pl-1 pr-1 pb-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <!-- <p>{{typeof radioCheckNoti || 'null' }}</p> -->
                    <v-radio-group
                      row
                      v-model="radioCheckNoti"
                      :rules="[
                        (v) =>
                          (v !== null && v !== undefined) ||
                          'กรุณาเลือกประเภทแจ้งเตือน',
                      ]"
                    >
                      <v-radio
                        :disabled="SelectGroupId != null"
                        label="แบบทั่วไป"
                        :value="true"
                      ></v-radio>
                      <v-radio
                        :disabled="SelectConsent != null"
                        label="แบบกลุ่ม"
                        :value="false"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center align-center pl-1 pr-1 pb-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1> </v-flex>
                </v-layout>
                <v-layout
                  v-if="radioCheckNoti === true"
                  row
                  wrap
                  justify-center
                  align-center
                  pa-1
                >
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <v-card outlined>
                      <v-card-text>
                        <v-flex xs11 sm11 md11 lg11 pa-1>
                          <b>หมายเลขความยินยอม <span style="color: red">*</span></b>
                          <v-flex xs12 sm12 md12 lg12 pa-1>
                            <v-autocomplete
                              return-object
                              item-text="HeaderConsent"
                              item-value="ConsentId"
                              :items="ItemConsent"
                              v-model="SelectConsent"
                              deletable-chips
                              color="info"
                              outlined
                              dense
                              chips
                              small-chips
                              @change="onConsentSelected"
                              :label="$t('mcg.consent2')"
                              :rules="[
                                (v) => {
                                  if (radioCheckNoti === true) {
                                    return !!v || $t('mcg.consent3'); // ตรวจตอนเป็น true
                                  }
                                  return true; // ไม่ต้อง validate ถ้าไม่ใช่ true
                                },
                              ]"
                            ></v-autocomplete>
                          </v-flex>
                        </v-flex>
                        <v-flex xs11 sm11 md11 lg11 pa-1>
                          <b>หมายเลขนโยบาย <span style="color: red">*</span></b>
                          <v-flex xs12 sm12 md12 lg12 pa-1>
                            <v-autocomplete
                              return-object
                              item-text="Title"
                              item-value="PolicyId"
                              :items="ItemPolicy"
                              v-model="SelectPolicy"
                              deletable-chips
                              color="info"
                              outlined
                              dense
                              chips
                              small-chips
                              @change="onPolicySelected"
                              :label="$t('mcg.policy2')"
                              :rules="[
                                (v) => {
                                  if (radioCheckNoti === true) {
                                    return !!v || $t('mcg.consent3'); // ตรวจตอนเป็น true
                                  }
                                  return true; // ไม่ต้อง validate ถ้าไม่ใช่ true
                                },
                              ]"
                            ></v-autocomplete>
                          </v-flex>
                        </v-flex>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout
                  v-if="radioCheckNoti === false"
                  row
                  wrap
                  justify-center
                  align-center
                  pa-1
                >
                  <v-flex xs11 sm11 md11 lg11>
                    <v-card outlined>
                      <v-card-text>
                        <v-flex xs11 sm11 md11 lg11 pa-1>
                          <b>หมายเลขกลุ่มความยินยอม <span style="color: red">*</span></b>
                          <v-autocomplete
                            return-object
                            item-text="GroupName"
                            item-value="GroupId"
                            :items="ItemsConsentData"
                            v-model="SelectGroupId"
                            deletable-chips
                            color="info"
                            outlined
                            dense
                            chips
                            small-chips
                            @change="onGourpIdSelected"
                            :label="$t('mcg.consent2')"
                            :rules="[
                              (v) => {
                                if (radioCheckNoti === false) {
                                  return !!v || $t('mcg.consent3'); // ตรวจตอนเป็น true
                                }
                                return true; // ไม่ต้อง validate ถ้าไม่ใช่ true
                              },
                            ]"
                          ></v-autocomplete>
                        </v-flex>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>หมายเลข Bot Oneplatform <span style="color: red">*</span></b>
                    <v-autocomplete
                      return-object
                      item-text="Name"
                      item-value="Id"
                      :items="ItemBot"
                      v-model="SelectBot"
                      deletable-chips
                      color="info"
                      outlined
                      dense
                      chips
                      small-chips
                      :label="$t('BotOnePlatform.choose_bot')"
                      :rules="[(v) => !!v || $t('BotOnePlatform.choose_bot2')]"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center align-center pa-1>
                  <v-flex xs11 sm11 md11 lg11 pa-1>
                    <b>หมายเลข TemplateBotOneplatform <span style="color: red">*</span></b>
                    <v-autocomplete
                      return-object
                      item-text="Name"
                      item-value="Id"
                      :items="ItemTemplate"
                      v-model="SelectTemplate"
                      deletable-chips
                      color="info"
                      outlined
                      dense
                      chips
                      small-chips
                      :label="$t('BotOnePlatform.template1')"
                      :rules="[(v) => !!v || $t('BotOnePlatform.template2')]"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-layout row wrap justify-center align-center pb-5>
                  <v-flex xs10 md3 lg3>
                    <v-btn
                      block
                      dark
                      color="#077893"
                      :loading="LoadingSave"
                      @click="Fn_CreateGroupsentBot"
                      >{{ $t("BotOnePlatform.create") }}</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { mapGetters } from "vuex";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {},
  data: () => {
    return {
      Name: "",
      PolicyId: "",
      ConsentId: "",
      BusinessId: "",
      BotOneplatformId: "",
      TemplateBotOneplatformId: "",
      GroupId: "",
      Bot_ID: "",
      ItemBot: [],
      SelectBot: "",
      Token_Bot: "",
      AccountId: "",
      SelectTemplate: "",
      radioCheckNoti: null,
      SelectPolicy: null,
      SelectConsent: null,
      SelectGroupId: null,
      ItemPolicy: [],
      ItemConsent: [],
      ItemsConsentData: [],
      ItemTemplate: [],
      Status: false,
      valid: true,
      LoadingSave: false,
      loadingDownloadData: false,
      SenderDisplayName: "",
      RuleEmailAddress: [
        (v) => !!v || "กรุณากรอกอีเมลแอดเดรสผู้ส่ง",
        (v) => /.+@.+\..+/.test(v) || "รูปแบบอีเมลไม่ถูกต้อง",
      ],
      RuleBotName: [(v) => !!(v && v.trim()) || "กรุณากรอกชื่อบอท"],
    };
  },
  computed: {
    ...mapGetters(["DataUpdateBot"]),

    _UpdateBotData: {
      get() {
        return this.DataUpdateBot || "-";
      },
    },
  },
  mounted() {
    this.Fn_GetDataOne();
    this.Fn_GetPolicyList();
    this.Fn_GetConsentList();
    this.Fn_GetDataConsentGroupList();
    this.Fn_GetAllBot();
    this.Fn_GetAllTemplate();
  },
  methods: {
    onChangeRadio() {},
    onGourpIdSelected() {},
    onPolicySelected() {},
    onConsentSelected() {},
    Fn_GetDataOne() {
      this.AccountId = this.$cookies.get("OneAccountId");
      this.BusinessId = this.$cookies.get("BusinessId");
    },
    Fn_BackIndex() {
      this.$router.push("/bot-index");
    },
    async Fn_GetAllTemplate() {
      this.isLoading = true;
      var biz_id = this.$cookies.get("BusinessId");
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var auth = await authorization.encodeDataNew(Headers);
      var headers = {
        Authorization: "Bearer " + auth,
        "Access-Control-Allow-Origin": "*",
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      };

      this.axios
        .get(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            `onechat/Template/${biz_id}`,
          {
            headers,
          }
        )
        .then((response) => {
          this.ItemTemplate = response.data.Message;
          this.ItemTemplate = this.ItemTemplate.map((item, index) => ({
            ...item, // กระจาย properties เดิมทั้งหมด
            no: index + 1, // เพิ่ม property no โดยเริ่มจาก 1
          }));
          // this.tableload = false;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetAllBot() {
      var biz_id = this.$cookies.get("BusinessId");
      var Name = "";
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var auth = await authorization.encodeDataNew(Headers);

      this.axios
        .get(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            `onechat/Bot/${biz_id}?Name=${Name}`,
          {
            headers: {
              Authorization: "Bearer " + auth,
              "ngrok-skip-browser-warning": "true",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.ItemBot = response.data.Message;
          this.tableload = false;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
          this.tableload = false;
        });
    },
    async Fn_CreateGroupsentBot() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        var data = {};

        if (this.radioCheckNoti === true) {
          data = {
            Name: this.Name,
            PolicyId: this.SelectPolicy.PolicyId,
            BusinessId: this.BusinessId,
            ConsentId: this.SelectConsent.ConsentId,
            GroupId: "",
            BotOneplatformId: this.SelectBot.Id,
            TemplateBotOneplatformId: this.SelectTemplate.Id,
            AccountId: this.AccountId,
          };
        } else if (this.radioCheckNoti === false) {
          data = {
            Name: this.Name,
            PolicyId: "",
            BusinessId: this.BusinessId,
            BotOneplatformId: this.SelectBot.Id,
            TemplateBotOneplatformId: this.SelectTemplate.Id,
            GroupId: this.SelectGroupId.GroupId,
            ConsentId: "",
            AccountId: this.AccountId,
          };
        }
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var auth = await authorization.encodeDataNew(Headers);
        var headers = {
          Authorization: "Bearer " + auth,
          "ngrok-skip-browser-warning": "true",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/GroupSend",
            data,
            { headers }
          )
          .then((response) => {
            if (response.status  == 200) {
              Toast.fire({
                icon: "success",
                title: this.$i18n.t("BotOnePlatform.created"),
              });
              this.$router.push("/bot-index");
            }
          })
          .catch((error) => {
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    async Fn_GetPolicyList() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetApiAllDetailPolicy",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
            this.ItemPolicy.filter(
              (i) => i.Status == true && i.Manage == "enable"
            );
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentList() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetApiAllDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsent = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetDataConsentGroupList() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetApiAllGroupConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemsConsentData = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
          this.$router.push("/profile");
        });
    },
  },
  watch: {},
};
</script>

<style></style>
